import {
  getSimplifiedLevels,
  getTraditionalLevels,
} from "@-/dev.improve.haniverse.assets.graphemes.levels";
import type { Level } from "@-/dev.improve.haniverse.lib.level";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";

/**
 * Returns grapheme level data for the user's current character script preference
 * (`hanziScript` on the actor user settings record).
 */
export function useLevels(): Level[] {
  const { hanziScript } = useActorUser();

  if (hanziScript === "traditional") {
    return getTraditionalLevels();
  }

  return getSimplifiedLevels();
}
